import { render, staticRenderFns } from "./DownloadTemplate.vue?vue&type=template&id=10f48af0"
import script from "./DownloadTemplate.vue?vue&type=script&lang=js"
export * from "./DownloadTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports